import { render, staticRenderFns } from "./consent-import-upload.vue?vue&type=template&id=b38e1494&scoped=true&"
import script from "./consent-import-upload.vue?vue&type=script&lang=js&"
export * from "./consent-import-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e1494",
  null
  
)

export default component.exports